<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="未绑定客户产品list"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="1100px"
        top="5vh"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap">
            <div class="tool-bar mb10">
                <el-button type="primary" :disabled="dataSelected.length<=0||isDisabled" @click="showBatchBindModal" class="mr10">批量绑定</el-button>
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="推广：">
                        <BatchMultipleSelect
                        ref="batchProductSelect"
                        :value="queryData['app_ids']"
                        :options="batchList.options"
                        :loading="batchList.loading"
                        title=""
                        :remote-method="remoteOptionsList"
                        @batch-submit="batchSubmitAccount"
                        @show-options="showSelectOptions('account')"
                        @change="changeOptionsSearch"
                        @clear-all="(val)=>clearBatchSearch(val)"
                        @change-all="(val)=>changeBatchSearchAll(val)"
                        batch-desc="输入或粘贴内容，每行一个"
                        :clearable="true"
                        :collapse-tags="true"
                        placeholder="推广名称、ID、内容搜索" />
                    </el-form-item>
                    
                    <el-form-item label="媒体：">
                        <ESelect v-model="queryData.plat_ids" multiple collapse-tags @change="submitSearch" clearable placeholder="全部媒体" style="width: 150px;">
                            <el-option v-for="item in platList"
                                        :label="item.name"
                                        :value="item.id"
                                        :key="item.id">{{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" @click="submitSearch">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="data-list">
                <el-table
                    ref="dataTable"
                    :data="dataList"
                    v-loading="dataLoading"
                    @selection-change="selectionChange"
                    tooltip-effect="dark"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :max-height="tableHeight"
                    stripe
                    style="width: 100%;">
                    <el-table-column
                        type="selection"
                        align="center"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="subproject_name"
                        label="推广名称"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="subproject_id"
                        label="推广ID"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="subproject_content"
                        label="推广内容"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <p class="package_name">{{scope.row.subproject_content||'--'}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="plat_name"
                        label="归属媒体"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="cur_company_name"
                        label="当前投放客户"
                        min-width="150">
                        <template slot-scope="scope">
                            <p class="package_name relative" :title="scope.row.cur_company_name">
                                <span class="ellipsis inline-block ver-middle" style="max-width: 70%;">{{scope.row.cur_company_name||'--'}}</span>
                                <span v-if="scope.row.cur_company_name" @click="checkCustomer(scope.row)" class="text-color-primary pointer ver-middle ml6">填入</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="account_name"
                        label="绑定客户"
                        align="center"
                        width="250">
                        <template slot-scope="scope">
                          <div class="tal">
                              <ESelect
                                  v-model="scope.row.customer_id"
                                  collapse-tags
                                  multiple
                                  filterable
                                  remote
                                  reserve-keyword
                                  :disabled="isDisabled"
                                  :placeholder="isDisabled?'暂无绑定权限':'请输入关键词'"
                                  :remote-method="(query)=>remoteMethod(query,scope.row)"
                                  :loading="scope.row.searchLoading">
                                  <el-option
                                      v-for="item in scope.row.customerList"
                                      :key="item.customer_id"
                                      :label="item.company_name"
                                      :value="item.customer_id">{{item.company_name}}
                                  </el-option>
                              </ESelect>
                          </div>

                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-bar tac mt10">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryData.pn"
                        :page-sizes="[30, 50,100,200]"
                        :page-size="queryData.rn"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCnt">
                    </el-pagination>
                </div>
            </div>
            <div class="modal-footer mt20 tac">
                <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" :disabled="isDisabled">保存</el-button>
            </div>
        </div>

        <el-dialog
            width="500px"
            title="批量绑定"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :visible.sync="innerDialogVisible"
            append-to-body>
            <el-form ref="dataForm" class="account-form mt20" :model="batchFormItem"  label-width="80px"
                     @keyup.enter.native="batchSubmit">

                <el-form-item label="绑定客户：">
                    <ESelect
                        class="full-w"
                        v-model="batchFormItem.customer_id"
                        collapse-tags
                        multiple
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请选择绑定客户"
                        :remote-method="batchRemoteMethod"
                        :loading="batchSearchLoading">
                        <el-option
                            v-for="item in batchCustomerList"
                            :key="item.customer_id"
                            :label="item.company_name"
                            :value="item.customer_id">{{item.company_name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item class="tac mt40" label-width="0">
                    <el-button type="default" @click="hideBatchModal" class="action-btn mr20">取消</el-button>
                    <el-button type="primary" @click="batchSubmit" class="action-btn ml20">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>



    </el-dialog>
</template>

<script>
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';
    import API from '@/api/baseInfo/customerApp.js';

    export default {
        name: "UnbindListModal",
        props:{
            isDisabled:Boolean,
            platList:{
                type:Array,
                default:function () {
                    return []
                }
            }
        },
        components:{
            BatchMultipleSelect
        },
        data(){
            return {
                dialogVisible:false,
                queryData:{
                    app_ids: [],
                    plat_ids: '',
                    pn:1,
                    rn:100,
                },
                batchList:{
                    options: [],
                    loading: false
                },
                allBatchListOptions:[],
                dataList:[],
                dataLoading:false,
                totalCnt:0,
                dataSelected:[],
                submitLoading:false,
                innerDialogVisible:false,
                batchFormItem:{
                    customer_id:[],
                },
                batchSearchLoading:false,
                batchCustomerList:[],
                tempBatchCustomerList:[],
                tableHeight:'350px',
            }
        },
        mounted() {
            window.addEventListener("resize", this.getTableMaxHeight);
            this.getTableMaxHeight();
        },
        beforeDestroy(){
            window.removeEventListener("resize", this.getTableMaxHeight);
        },
        methods:{
            getTableMaxHeight(){
                let bodyHeight  = document.body.clientHeight|| document.documentElement.clientHeight || window.innerHeight;
                let tableHeight = Math.round((bodyHeight*0.8) - 100 - 120);
                this.tableHeight =  tableHeight>350?tableHeight+'px':'350px';
            },
            handleClose(){
                this.dialogVisible = false;
            },
            submitSearch() {
                this.queryData.pn = 1;
                this.queryData.rn = 100;
                this.getDataList();
            },
            showModal(){
                this.dialogVisible = true;
                this.queryData.app_ids = [];
                this.queryData.plat_ids = '';
                this.queryData.pn = 1;
                this.queryData.rn = 100;
                this.getDataList();
            },
            // 未绑定客户产品LIST-产品搜索筛选下拉框数据 postAppSelectList
            remoteOptionsList(query) {
                if (query != '') {
                    this.batchList.loading = true;
                    API.postAppSelectList({
                        search:query,
                    }).then(res=>{
                        this.batchList.loading = false;
                        let resData = res.data||{};
                        this.batchList.options = (resData.list||[]).map(item=>{
                            return {
                                value:item.subitem_id,
                                label:`${item.subproject_name}(${item.subitem_id})(${item.subproject_content})`
                            }
                        });

                        this.batchList.options.forEach(item=>{
                            if(!this.allBatchListOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allBatchListOptions.push({...item});
                            }
                        });
                    },err=>{
                        this.batchList.loading = false;
                        console.log('getAccountOptionList err',err);
                        this.batchList.options = [];
                    })
                } else {

                }
            },
            batchSubmitAccount(con){
                API.postAppSelectList({
                    batch_search:con,
                }).then(res=>{
                    this.$refs.batchProductSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下产品，请核实，是否需要剔除未找到的产品?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchAccount(successList);
                            this.$refs.batchProductSelect.hideBatchModal();
                        });
                    }else{
                        this.addBatchAccount(successList);
                        this.$refs.batchProductSelect.hideBatchModal();
                    }
                },err=>{
                    console.log('getAccountOptionList batch error', err);
                    this.$refs.batchProductSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            addBatchAccount(list){
                let accountIdList = this.batchList.options.map(item=>item.value);
                (list||[]).forEach(item=>{
                    if(!accountIdList.includes(item.company_id)){
                        this.batchList.options.push({
                            value:item.subitem_id,
                            label:`${item.subproject_name}(${item.subitem_id})(${item.subproject_content})`
                        });

                        this.batchList.options.forEach(item=>{
                            if(!this.allBatchListOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allBatchListOptions.push({...item});
                            }
                        });
                    }
                    if(!this.queryData.app_ids.includes(item.subitem_id)){
                        this.queryData.app_ids.push(item.subitem_id);
                    }
                })
            },
            showSelectOptions(type){
                let value = this.queryData.app_ids;
                this.batchList.options = value.map(item=>{
                    let allOptions = [];
                    allOptions = this.allBatchListOptions||[];
                    let actionItem = allOptions.find(inner=>inner.value==item);
                    return {
                        label:actionItem?actionItem.label:item,
                        value:item,
                    }
                })
            },
            changeOptionsSearch(val){
                this.queryData.app_ids = [...val];
                this.queryData.pn = 1;
                this.queryData.rn = 100;
                this.getDataList();
            },
            clearBatchSearch(val=[]){
                val.forEach(item=>{
                    let index = this.queryData['app_ids'].findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.queryData['app_ids'].splice(index,1);
                    }
                })
            },
            changeBatchSearchAll(val){
                let oldVal = this.queryData['app_ids'];
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.$set(this.queryData,'app_ids',oldVal.concat(newVal));
            },
            getDataList(){
                this.dataLoading = true;
                API.getUnbindAppList(this.queryData).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    let list = resData.list||[];
                    this.totalCnt = resData.totalCnt;

                    this.dataList = list.map(item=>{
                        item.cur_customer_id = item.customer_id;
                        item.cur_company_name = item.company_name;
                        item.customer_id = [];
                        item.searchLoading = false;
                        item.customerList = [];
                        return item;
                    });
                    console.log(11111,this.dataList);
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            handleSubmit(){
                let bindList = this.dataList.filter(item=>{
                    let customerId = item.customer_id||[];
                    return customerId.length>0;
                });
                console.log(bindList);
                if(bindList.length<=0) return this.$message.error('请先绑定客户后提交');

                this.submitLoading = true;
                API.saveUnbindApp({
                    plat_id_app_id_customer_ids: bindList.map(item=>{
                        let customerIds = item.customer_id.join(',');
                        return `${item.plat_id}-${item.subitem_id}-${customerIds}`;
                    }),
                }).then(res => {
                    console.log('saveUnbindApp',res);
                    this.$message.success(res.info||'操作成功');
                    this.submitLoading = false;
                    this.getDataList();
                    this.$emit('update');
                }, (err) => {
                    console.log('saveUnbindApp err',err);
                    this.submitLoading = false;
                    this.$message.error(err.info||'操作失败');
                });
            },
            hideModal(){
                this.handleClose();
                this.dataList = [];
                this.$emit('close');
            },
            showBatchBindModal(){
                this.innerDialogVisible = true;
                this.batchFormItem.customer_id = [];
                this.batchSearchLoading = false;
                this.batchCustomerList = false;
                this.tempBatchCustomerList = [];
            },
            selectionChange(val){
                this.dataSelected = val.map(item => item);
            },
            batchSubmit(){
                if(this.batchFormItem.customer_id.length<=0) return this.$message.error('请选择绑定客户');
                let batchSelected = this.batchFormItem.customer_id.map(id=>this.tempBatchCustomerList.find(item=>item.customer_id==id));
                this.dataSelected.forEach(row=>{
                    this.$set(row,'customer_id',this.batchFormItem.customer_id);
                    this.$set(row,'customerList',batchSelected);
                });
                this.innerDialogVisible = false;
                // 清空缓存的列表
                this.tempBatchCustomerList = [];
            },
            hideBatchModal(){
                this.innerDialogVisible = false;
                // 清空缓存的列表
                this.tempBatchCustomerList = [];
            },
            remoteMethod(query,item){
                console.log('remoteMethod',query,item);
                this.$set(item,'searchLoading',true);
                API.getCompanySelector({
                    search:query,
                }).then(res=>{
                    console.log('getCompanySelector',res);
                    let resData = res.data||[];
                    this.$set(item,'searchLoading',false);
                    this.$set(item,'customerList',resData);
                },err=>{
                    console.log('getCompanySelector err',err);
                    this.$message.error(err.info||'请求失败');
                    this.companyLoading = false;
                    this.$set(item,'searchLoading',false);
                })
            },
            batchRemoteMethod(query){
                this.batchSearchLoading = true;
                API.getCompanySelector({
                    search:query,
                }).then(res=>{
                    console.log('getCompanySelector',res);
                    let resData = res.data||[];
                    this.batchSearchLoading = false;
                    this.batchCustomerList = resData;
                    resData.forEach(item=>{
                        let tempItem = this.tempBatchCustomerList.find(inner=>inner.customer_id==item.customer_id);
                        if(!tempItem){
                            this.tempBatchCustomerList.push(item);
                        }
                    })
                },err=>{
                    console.log('getCompanySelector err',err);
                    this.$message.error(err.info||'请求失败');
                    this.batchSearchLoading = false;
                })
            },
            checkCustomer(row){
                console.log('checkCustomer',row);
                row.searchLoading = true;
                API.checkCustomer({
                    customer_id:row.cur_customer_id,
                }).then(res=>{
                    console.log('checkCustomer',res);
                    row.searchLoading = false;
                    this.$set(row,'customerList',[{
                        customer_id:row.cur_customer_id,
                        company_name:row.company_name,
                    }]);
                    this.$set(row,'customer_id',[row.cur_customer_id]);

                    console.log(22222,row)
                },err=>{
                    console.log('checkCustomer err',err);
                    row.searchLoading = false;
                    this.$message.error(err.info||'请求失败');
                });
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .package_name{
        line-height: 16px;
    }
    ::v-deep .el-dialog__body{
        padding: 10px 30px 20px;
    }
    .tool-bar{
        display: flex;
        align-items: center;
        .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
            margin-bottom: 0;
        }
    }
</style>
